/* @flow */
import * as React from 'react';
import { Link } from 'react-router-dom';
import ReactPlaceholder from 'react-placeholder';

import styles from './ChartKeys.module.scss';

type TypeChartKeys = {|
  keys: Object,
  widgetSize: string,
  showPlaceholders: boolean,
|};

function isDisabledLink(count) {
  return count === 0 ? styles['disabled-link'] : '';
}

function hasStyle(style) {
  return typeof styles[style] === 'undefined' ? '' : styles[style];
}

function ChartKeys({ keys, widgetSize, showPlaceholders }: TypeChartKeys) {
  return (
    <ul className={`${styles['chart-keys']} ${hasStyle(widgetSize)}`.trim()}>
      {keys.map((item, index) => (
        <li key={index.toString()}>
          <Link
            className={`${isDisabledLink(item.total)}`}
            style={{ color: item.color }}
            to={item.to}
          >
            <ReactPlaceholder
              ready={!showPlaceholders}
              type="textRow"
              color={item.color}
              style={{ width: '30%', marginBottom: 8 }}
            >
              <span>{item.total}</span>
            </ReactPlaceholder>
            {item.label}
          </Link>
        </li>
      ))}
    </ul>
  );
}

export default ChartKeys;
